module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.3cd78665.ttf";